import HomeCookRouter from "./routers";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import ApplicationProvider from "./contexts";

const queryClient = new QueryClient();

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ApplicationProvider>
        <div className="App">
          <HomeCookRouter />
        </div>
      </ApplicationProvider>
    </QueryClientProvider>
  );
}

export default App;